var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLoation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 65,
    viewBox: "0 0 40 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 5C29.9408 5 37.9995 13.1514 37.9995 23.2067C37.9995 26.5233 37.1253 29.631 35.5909 32.3111C34.568 34.0977 29.3709 43.2007 19.9998 59.62C10.6286 43.2007 5.43157 34.0977 4.40865 32.3111C2.87427 29.631 2 26.5233 2 23.2067C2 13.1514 10.0588 5 19.9998 5ZM19.9998 15.4038C15.7393 15.4038 12.2856 18.8973 12.2856 23.2067C12.2856 27.5161 15.7393 31.0095 19.9998 31.0095C24.2602 31.0095 27.714 27.5161 27.714 23.2067C27.714 18.8973 24.2602 15.4038 19.9998 15.4038Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0003,
    cy: 24.1995,
    r: 9.59988,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3994 22.9647C10.3994 19.1541 12.5649 15.8492 15.7325 14.2136L19.8643 11L19.3342 13.1634C19.6332 13.136 19.936 13.122 20.2421 13.122C25.6781 13.122 30.0848 17.5288 30.0848 22.9647C30.0848 26.567 28.1496 29.7174 25.2621 31.4328L20.2442 35.679L21.2291 32.7586C20.9045 32.7909 20.5752 32.8074 20.2421 32.8074C14.8061 32.8074 10.3994 28.4007 10.3994 22.9647ZM20.2416 27.3393C22.6576 27.3393 24.6162 25.3808 24.6162 22.9648C24.6162 20.5488 22.6576 18.5902 20.2416 18.5902C17.8256 18.5902 15.8671 20.5488 15.8671 22.9648C15.8671 25.3808 17.8256 27.3393 20.2416 27.3393Z",
    fill: "#FF7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoation);
export default __webpack_public_path__ + "static/media/new-loation.afc68771bbafeabb2b9595606ac19103.svg";
export { ForwardRef as ReactComponent };